import React from 'react';
import { CombineClasses } from '../../Utility/ReactUtils';
const iconPackToClass = {
    'icons-outlined': 'material-icons-outlined',
    'symbols-outlined': 'material-symbols-outlined',
};
export default function MaterialIcon(props) {
    const { icon, className, iconPack = 'symbols-outlined', as = 'span', ...rest } = props;
    const iconPackClassName = iconPackToClass[iconPack] ?? '';
    return React.createElement(as, {
        className: CombineClasses(className, iconPackClassName),
        ...rest,
    }, icon);
}
//# sourceMappingURL=MaterialIcon.js.map